/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';
import * as _ from 'underscore';

export const everqueue = (state = defaultState.everqueue, action) => {
    let nextState = Utilities.deepClone(state),
        i = 0;

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.EVERQUEUE_LIST:
                let keys = Object.keys(action.payload);
                if (keys.length === 0 || keys.length < 20) {
                    nextState.hasMore = false;
                }
                for (i = 0; i < keys.length; ++i) {
                    if (nextState.list.find(({id}) => { id === action.payload[keys[i]].id}) === undefined) {
                        nextState.list.push(action.payload[keys[i]]);
                    }
                }
                break;

            case constants.EVERQUEUE_UPDATE:
                break;

            case constants.EVERQUEUE_DELETE:
                // noop for success
                break;

            default:
                break;
        }
    } else if (action.status === constants.STATE_TXRX && action.type === constants.EVERQUEUE_LIST) {
        // build in a way to reset the everqueue since switching from one queue
        // to another
        if (action.post.reset !== undefined && action.post.reset) {
            nextState.list = [];
            nextState.hasMore = true;
        }
    } else if (action.status === constants.STATE_TXRX && action.type === constants.EVERQUEUE_DELETE) {
        // reset the list when 'delete all' is dispatched
        if (action.post.sledgehammer !== undefined && action.post.sledgehammer) {
            nextState.list = [];
            nextState.hasMore = true;
        }
    }
    return nextState;
};
